import { render, staticRenderFns } from "./MobileSocialResponsibility.vue?vue&type=template&id=41461562&scoped=true&"
import script from "./MobileSocialResponsibility.vue?vue&type=script&lang=js&"
export * from "./MobileSocialResponsibility.vue?vue&type=script&lang=js&"
import style0 from "./MobileSocialResponsibility.vue?vue&type=style&index=0&id=41461562&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41461562",
  null
  
)

export default component.exports